import { useState } from 'react'
import getOr from 'lodash/fp/getOr'
import api from 'utils/api'
import { useHistory } from 'react-router-dom'
import { useStore } from 'store/GlobalContext'

export default () => {
  const history = useHistory()
  const [fetching, setFetching] = useState(false)
  const [error, setError] = useState(null)
  const [, dispatch] = useStore()

  const logout = () => {
    dispatch({ type: 'logout' })
    localStorage.setItem('token', null)
    history.push('/login')
  }

  // TODO: add session information to LOGROCKET
  const login = ({ username, password, redirectTo }) => {
    setFetching(true)

    api
      .post('login', { username, password })
      .then(({ data }) => {
        localStorage.setItem('token', data.token)
        dispatch({ type: 'login' })
        setFetching(false)
        setError(null)
        history.push(redirectTo)
      })
      .catch(() => {
        setFetching(false)
        setError('Invalid username and/or password.')
      })
  }

  // TODO: add session information to LOGROCKET
  const autoLogin = ({ redirectTo }) => {
    setFetching(true)

    api
      .get('login/refresh')
      .then(({ data }) => {
        localStorage.setItem('token', data.token)
        dispatch({ type: 'login' })
      })
      .then(getLoggedInUserKids)
      .then(() => {
        setFetching(false)
        setError(null)
        history.push(redirectTo)
      })
      .catch(() => {
        setFetching(false)
        logout()
      })
  }

  const refreshLogin = () =>
    api
      .get('/login/refresh')
      .then(({ data }) => {
        localStorage.setItem('token', data.token)
        dispatch({ type: 'login' })
      })
      .catch(() => {})

  const getLoggedInUserKids = () => {
    api(`/parents/kids`)
      .then(({ data }) =>
        dispatch({ type: 'setKids', payload: getOr([], 'kids', data) })
      )
      .catch(() => {})
  }

  return {
    logout,
    login,
    autoLogin,
    refreshLogin,
    fetching,
    error,
  }
}
